import { z } from 'zod';

export interface DeviceStatus {
    healthy: boolean;
    messages: string[];
}

export const deviceStatusSchema = z.object({
    healthy: z.boolean(),
    messages: z.array(z.string()),
});
